import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsSpeakerdeckComponent } from './simple-icons-speakerdeck.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsSpeakerdeckComponent ],
    exports:      [ SimpleIconsSpeakerdeckComponent ],
    bootstrap:    []
})
export class SimpleIconsSpeakerdeckModule {}
